import React, { useState, useEffect } from "react";
import { Grid, Box, Container, Slide, Fade } from "@mui/material";
import { Login } from "../Login";

export const LoginLandingPage = ({ showLoginInitially = false }) => {
  const [showLogin, setShowLogin] = useState(showLoginInitially);
  
  // Make the setShowLogin function available to external components
  // This allows the header to directly control the login overlay
  React.useEffect(() => {
    // Make the setter function globally available
    window.showLoginOverlay = () => setShowLogin(true);
    
    return () => {
      // Cleanup when component unmounts
      window.showLoginOverlay = undefined;
    };
  }, []);
  
  // Custom LandingPage with Get Started button handler
  const CustomLandingPage = () => {
    // Enhanced version of LandingPage that passes the click handler
    const handleGetStarted = () => {
      setShowLogin(true);
    };
    
    return (
      <Box sx={{ width: "100%" }}>
        <LandingPageWrapper onGetStartedClick={handleGetStarted} />
      </Box>
    );
  };
  
  // Wrapper component for LandingPage to inject the click handler
  const LandingPageWrapper = ({ onGetStartedClick }) => {
    // This is a modified version of the LandingPage that accepts a click handler
    const { default: OriginalLandingPage } = require("../LandingPage");
    
    // Clone the LandingPage element and add our custom handler
    return React.cloneElement(<OriginalLandingPage />, {
      onGetStartedClick: onGetStartedClick
    });
  };

  // Close login overlay handler
  const handleCloseLogin = () => {
    setShowLogin(false);
  };

  return (
    <Container maxWidth="xl" disableGutters>
      {/* LandingPage content (always full width) */}
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <CustomLandingPage />
        </Grid>
      </Grid>
      
      {/* Login overlay (positioned absolutely over the landing page) */}
      {showLogin && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            zIndex: 1200,
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent overlay
          }}
          onClick={(e) => {
            // Close login when clicking on the overlay background
            if (e.target === e.currentTarget) {
              handleCloseLogin();
            }
          }}
        >
          <Slide direction="left" in={showLogin} mountOnEnter unmountOnExit>
            <Fade in={showLogin} timeout={800}>
              <Box 
                sx={{
                  height: "100vh",
                  display: "flex", 
                  justifyContent: "center", 
                  alignItems: "center",
                  padding: 2,
                  backgroundColor: "#f5f5f5",
                  boxShadow: "-5px 0 10px rgba(0, 0, 0, 0.1)",
                  width: { xs: "100%", md: "400px" }, // Fixed width on medium screens and up
                  maxWidth: "100%",
                  overflow: "auto"
                }}
                onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the login box
              >
                <Login />
              </Box>
            </Fade>
          </Slide>
        </Box>
      )}
    </Container>
  );
};

export default LoginLandingPage;